import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Axios from "axios";
import DatePicker from "react-datepicker";
import Select from "react-select-virtualized";
import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBModal,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCardFooter,
  MDBBtn,
  MDBBtnGroup,
  MDBTooltip,
} from "mdbreact";
import { toast, ToastContainer } from "react-toastify";

import "../css/scrollbar.css";

import AccessDenied from "../components/AccessDenied";

import AddEditSalesMain from "./AddEditSalesMain";

import Sales from "./Sales";
import { setDate } from "date-fns/esm";
import SalesHistory from "./SalesHistory";
import DeleteSalesMain from "./DeleteSalesMain";
const SalesMain = (props) => {
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };

  var date = new Date();

  const [frm, setValues] = useState({
    // DateFrom:new Date(date.getFullYear(),date.getMonth() ,1)
    DateFrom: new Date(),
    DateTo: new Date(),
    useFilter: true,
    deleted: false,
    requesttype: { value: "147", label: "MEDICAL" },
  });

  // const [frm, setValues] = useState({
  //   code:''
  //   ,deliveredby:''
  //   ,paid:false
  //   ,usercode:sessionStorage.getItem("msal.uc")
  // });

  const updateField = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      value = target.checked;
      setValues({ ...frm, [name]: value });
    } else {
      setValues({ ...frm, [name]: value });
    }
  };

  const [rows, setRows] = useState([]);
  const [showPreloader, setPreloader] = useState("normal");
  const [strTransactions, setTransactions] = useState("");
  const [selRow, setSelectedRow] = useState("");

  const [modalAddEdit, showAddEdit] = useState(false);

  const toggleAddEdit = (transtype) => {
    setRows([]);

    showAddEdit(!modalAddEdit);

    loadData();
  };

  const [modalWarning, showWarningBox] = useState(false);

  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  };

  const toastId = React.useRef(null);

  const notify = (message) => {
    toastId.current = toast.info(message);
  };

  const [dateToday, setDateToday] = useState(String(new Date()));
  const [bRefresh, setRefresh] = useState(false);

  const refreshGrid = () => {
    setRows([]);
    setRefresh(!bRefresh);

    loadData();
  };

  const showResult = (message) => {
    setRefresh(!bRefresh);

    setRows([]);

    // loadData();

    loadData();

    toast.info(message, {
      closeButton: false,
    });
  };

  function loadData() {
    Axios.get(
      props.apiServer +
        "/transactionsadmin?DateFrom=" +
        frm.DateFrom.toDateString() +
        "&DateTo=" +
        frm.DateTo.toDateString() +
        "&token=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        setRows(res.data);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  const [errorMessage, setErrorMessage] = useState("");

  const getDateValue = (dtPickerName) => (actualValue) => {
    setValues({ ...frm, [dtPickerName]: actualValue });
  };

  const useMountEffect = (functionName) => useEffect(functionName, []);

  function ObtainDate() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();
    today = mm + "/" + dd + "/" + yyyy;
    setDateToday(today);
  }

  function submitHandler(event) {
    event.preventDefault();
    event.target.className += " was-validated";

    loadData();
  }

  // useMountEffect(loadData);
  useMountEffect(ObtainDate);

  useEffect(() => {
    loadData();
  }, [strTransactions]);

  return (
    <React.Fragment>
      <form className="needs-validation" onSubmit={submitHandler} noValidate>
        <MDBRow>
          <MDBCol md="12">
            {showPreloader === "normal" ? (
              <MDBRow>
                <MDBCol md="4"></MDBCol>
                <MDBCol md="4" className="text-center">
                  <br />
                  <img
                    src={props.deployURL + "/loading.gif"}
                    style={{ width: "300px", textAlign: "center" }}
                    alt="loading"
                  />
                  <br />
                </MDBCol>
                <MDBCol md="4"></MDBCol>
              </MDBRow>
            ) : (
              <React.Fragment>
                <MDBRow>
                  <MDBCol md="8">
                    <h6
                      style={{ fontFamily: "Montserrat", fontWeight: "400" }}
                      className="display-5 blue-grey-text ml-1"
                    >
                      {" "}
                      TRANSACTIONS
                    </h6>
                  </MDBCol>
                  <MDBCol md="4"></MDBCol>
                </MDBRow>

                <MDBRow>
                  <MDBCol md="2" className="text-left">
                    <label className="grey-text">
                      <small>&nbsp;Date From</small>
                    </label>
                  </MDBCol>
                  <MDBCol md="2" className="text-left">
                    <label className="grey-text">
                      <small>&nbsp;Date To</small>
                    </label>
                  </MDBCol>

                  <MDBCol md="2" className="text-left"></MDBCol>
                </MDBRow>
                <MDBRow className="d-flex flex-row">
                  <MDBCol md="2" className="text-left">
                    <DatePicker
                      selected={frm.DateFrom}
                      onChange={getDateValue("DateFrom")}
                    />
                  </MDBCol>

                  <MDBCol md="2" className="text-left">
                    <DatePicker
                      selected={frm.DateTo}
                      onChange={getDateValue("DateTo")}
                    />
                  </MDBCol>

                  <MDBCol md="4" className="text-left">
                    <MDBBtnGroup>
                      {/* <MDBBtn  className="mb-5" color="primary" type="button" title="Add Customer Ticket"  onClick={toggleAddEdit}>
                                  <MDBIcon icon="plus" size="2x" className="pr-2" />
                             
                                </MDBBtn> */}
                      <MDBBtn
                        className="mb-5"
                        color="primary"
                        size="sm"
                        type="submit"
                        title="Refresh"
                      >
                        <MDBIcon icon="sync-alt" size="2x" className="pr-2" />
                      </MDBBtn>
                    </MDBBtnGroup>
                  </MDBCol>
                </MDBRow>

                <MaterialTable
                  title=""
                  columns={[
                    {
                      title: "Customer Ticket",
                      field: "code",
                      editable: "never",
                    },
                    {
                      title: "Transaction Date",
                      field: "transactiondateshort",
                      type: "date",
                      editable: "never",
                      filtering: false,
                    },
                    { title: "Discount", field: "discount", editable: "never" },
                    {
                      title: "Total Sales",
                      field: "totalsales",
                      editable: "never",
                    },
                    {
                      title: "Cashier",
                      field: "encodedby",
                      editable: "never",
                      defaultGroupOrder: 0,
                    },
                    {
                      title: "Reference Number",
                      field: "referenceno",
                      editable: "never",
                    },
                    {
                      title: "Deleted",
                      field: "deleted",
                      editable: "never",
                      lookup: { deleted: "deleted", active: "active" },
                    },
                    {
                      title: "Printed",
                      field: "printed",
                      editable: "never",
                      render: (rowData) => (
                        <React.Fragment>
                          {rowData.printed === "Invoice Printed" ? (
                            <>
                              <span className="black-text">
                                {rowData.printed}
                              </span>
                            </>
                          ) : (
                            <>
                              <span className="red-text font-weight-bold">
                                {rowData.printed}
                              </span>
                            </>
                          )}
                        </React.Fragment>
                      ),
                    },
                  ]}
                  data={rows}
                  options={{
                    search: true,

                    filtering: true,
                    grouping: true,
                    detailPanelType: "single",
                    // pageSize: 50,
                    // pageSizeOptions: [50, 100, 500],
                  }}
                  detailPanel={[
                    {
                      icon: () => <MDBIcon icon="list" className="blue-text" />,
                      openIcon: () => (
                        <MDBIcon
                          icon="chevron-circle-down"
                          className="red-text"
                        />
                      ),
                      tooltip: "Sales Details",
                      render: (rowData) => {
                        return (
                          <MDBContainer className="ml-5 pl-5">
                            {/* <MDBCardHeader className="cloudy-knoxville-gradient">
                            <span className="font-weight-bold"> SALES DETAILS &nbsp; <span className="blue-text">{rowData.code}</span>
                              </span>
                          </MDBCardHeader>  

                           */}
                            <DeleteSalesMain
                              deployURL={props.deployURL}
                              apiServer={props.apiServer}
                              code={rowData.code}
                              dealercode={rowData.dealercode}
                              parentcode={rowData.code}
                              apiServerHybrid={props.apiServerHybrid}
                              discountcode={rowData.discountcode}
                              discounttype={rowData.discount}
                              discountrate={rowData.discountrate}
                              toggleModal={toggleAddEdit}
                              refreshGrid={refreshGrid}
                              showResult={showResult}
                            ></DeleteSalesMain>

                            <MDBCardFooter></MDBCardFooter>
                          </MDBContainer>
                        );
                      },
                    },
                  ]}
                />
              </React.Fragment>
            )}
          </MDBCol>
        </MDBRow>

        <MDBModal
          backdrop={false}
          isOpen={modalAddEdit}
          toggleModal={toggleAddEdit}
          fullHeight
          position="right"
          size="lg"
        >
          <MDBCard>
            <MDBCardHeader className="primary-color">
              <h5 className="h5-responsive white-text">
                <MDBIcon icon="shopping-cart" />
                &nbsp;<b>Add Customer Ticket</b>
              </h5>
            </MDBCardHeader>
            <MDBCardBody>
              <AddEditSalesMain
                deployURL={props.deployURL}
                apiServer={props.apiServer}
                code="new"
                apiServerHybrid={props.apiServerHybrid}
                toggleModal={toggleAddEdit}
                refreshGrid={refreshGrid}
              ></AddEditSalesMain>
            </MDBCardBody>
          </MDBCard>

          {/* <AddEditDirectiveDetails toggleModal={toggleAddEdit} code={"newrecord"} directivecode={props.code}  apiServer={props.apiServer} loadDirectivesMain={props.loadDirectivesMain}/> */}
        </MDBModal>

        <ToastContainer
          hideProgressBar={true}
          newestOnTop={true}
          autoClose={2000}
        />
      </form>
    </React.Fragment>
  );
};

export default SalesMain;
